<nb-layout>
    <nb-layout-header fixed>
        <img src="{{baseUrl}}/img/logo.png"/>
    </nb-layout-header>
    <nb-layout-column>
        <router-outlet></router-outlet>
    </nb-layout-column>
</nb-layout>
